import { useIsComerciales } from './feature-app';

export const LINK = {
	HOME_VW: 'https://www.volkswagen.es/es.html',
	STOCK: 'https://www.volkswagen.es/stock/',
	MATCH: 'https://www.volkswagen.es/es/match.html',
	CITA_PREVIA: 'https://www.volkswagen.es/es/cita-previa.html',
	CITA_PREVIA_CANARIAS: 'https://www.vwcanarias.com/es/cita-previa.html',
	CITA_CANARIAS: 'https://cita.vwcanarias.com/',
	SHOWROOM: 'https://www.volkswagen.es/es/modelos/{carline}.html',
	CONFIGURADOR:
		'https://www.volkswagen.es/es/configurador.html/__app/{carline}.app',
	LEGAL_PRIVACIDAD:
		'https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html',
	EMAIL_ATENCION_CLIENTE: 'atencioncliente@volkswagen.es',
	THE_ORIGINALS: 'https://www.theoriginals.es',

	// COMERCIALES
	HOME_VW_CIAL: 'https://www.volkswagen-comerciales.es/es.html',
	LEGAL_PRIVACIDAD_CIAL:
		'https://www.volkswagen-comerciales.es/es/volkswagen-espana/datos-privacidad.html',
	EMAIL_ATENCION_CLIENTE_CIAL:
		'atencioncliente.volkswagencomerciales@volkswagen.es',
};

export const getLinkHome = () => {
	const isComerciales = useIsComerciales();
	return isComerciales ? LINK.HOME_VW_CIAL : LINK.HOME_VW;
};

export const getLinkPoliticaPrivacidad = () => {
	const isComerciales = useIsComerciales();
	return isComerciales ? LINK.LEGAL_PRIVACIDAD_CIAL : LINK.LEGAL_PRIVACIDAD;
};

export const getMailAtencionCliente = () => {
	const isComerciales = useIsComerciales();
	return isComerciales
		? LINK.EMAIL_ATENCION_CLIENTE_CIAL
		: LINK.EMAIL_ATENCION_CLIENTE;
};
